/* Shared add-on hit area. Use the native control so each PDP owns its state/cart. */
(() => {
  const cards = '.hx27-addon,.afd-accessory,.finishing-card,.catalog-compatible-grid > article,.accessory-card';
  const controls = 'a,button,input,select,textarea,label,[role="checkbox"],[role="radio"],[role="combobox"],summary';
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.target.closest(controls)) return;
    const card = event.target.closest(cards);
    if (!card) return;
    const checkbox = card.querySelector('[role="checkbox"]') || card.querySelector('input[type="checkbox"]');
    if (!checkbox || checkbox.disabled || checkbox.getAttribute('aria-disabled') === 'true') return;
    // Prevent a second toggle from older per-brand card handlers.
    event.stopPropagation();
    checkbox.click();
  }, true);
})();
